import React from 'react'
import classNames from 'classnames'
import s from './divider.scss'
import {DividerProps} from './index'

export const Divider = ({className}: DividerProps) => <div className={classNames(s.divider, className)} />
